import { message } from 'antd';
import { AxiosError } from 'axios';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@/services/api';
import type { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';

type UpdateElementRequest = BaseContext & {
	report_id: string;
	evaluation_element: {
		id: string;
		checked: boolean;
	};
};

type UpdateElementResponse = {
	saved_report_element: {
		id: string;
		report_id: string;
		element_id: string;
		updated_at: Date;
		created_at: Date;
	};
	step: number;
};

type UpdateElementError = AxiosError<any>;

async function updateElement(parameters: UpdateElementRequest): Promise<UpdateElementResponse> {
	const url = `/ergonomic-tool/rosa/evaluation`;
	const { data } = await Api.put<UpdateElementResponse>(url, parameters);
	return data;
}

export const useUpdateElement = ({ report_id, organization_id, company_id }: any) => {
	const queryClient = useQueryClient();
	return useMutation<UpdateElementResponse, UpdateElementError, any>(
		async ({ evaluation_element }) => {
			const payload = {
				report_id,
				organization_id,
				company_id,
				evaluation_element
			};

			return await updateElement(payload);
		},
		{
			onError: () => {
				message.error(I18n.get('Error save element!'));
			},
			onSuccess: () => {
				queryClient.invalidateQueries([ROSA_QUERY_KEYS.GET_SCORES]);
			}
		}
	);
};
